import defaultClient from '@/plugins/axios/defaultClient'

export default {
  getPlans() {
    return defaultClient.get('/plans/plans')
  },
  // /**
  //  *
  //  * @param {
  //  * {
  //  *   "plan": "3ec331c3-a21a-4e8e-9016-e592cff7ffe9",
  //  * }
  //  * } plan
  //  * @returns
  //  */
  postPlanChanges(plan) {
    return defaultClient.post('/plans/change-requests', plan)
  },
  getMyPlanChoices() {
    return defaultClient.get('/plans/choices/current')
  },
}
